// import RNFetchBlob from 'rn-fetch-blob';
import {FetchParams, PostParams, PutParams, RejectErrorValue} from 'redux-thunk-kit';
import {thunk} from '~/utils/thunk';
import {ENDPOINTS} from '~/constants';
import {AppDispatch} from '~/redux/root-store';
import {createAsyncThunk} from '@reduxjs/toolkit';
import request from '~/utils/request';
import AppError from '~/utils/error-handler';
import {GetSignedUrlS3ApiItem, UploadImageModules} from '~/types/models/app';

export interface FetchAppsParams extends FetchParams {
  [key: string]: any;
}

export interface GetSignedUrlS3Params extends FetchParams {
  [key: string]: any;
  file: string;
}

export interface UploadFileToServer extends PostParams {
  [key: string]: any;
  data: {
    type: UploadImageModules;
    fileName: string;
    filePath: string;
  };
}

export interface UpdateAppParams extends PutParams {
  [key: string]: any;
  data: {};
  id: number;
}

const query = thunk.query('app');

// @Refer: Academy admin code base
export const uploadFile = createAsyncThunk<
  {accessUrl: string; uid: string},
  {type: string; fileName: string; file: File; endpoint?: string},
  {dispatch: AppDispatch; rejectValue: RejectErrorValue}
>('file/upload', async ({type, fileName, file, endpoint}, {rejectWithValue}) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('medicalFormFile', file);
    formData.append('type', type);

    const res = await request.post(endpoint ? endpoint : ENDPOINTS.FILE_UPLOAD, formData);
    // @ts-ignore
    const {url: accessUrl, uid} = res.data.data;

    return {accessUrl, uid};
  } catch (e) {
    new AppError(e);
    return rejectWithValue({errMsg: 'Can not upload file!'} as RejectErrorValue);
  }
});

export const getSignedUrlS3 = query.fetch<GetSignedUrlS3Params, GetSignedUrlS3ApiItem>(
  `${ENDPOINTS.FILE_TEMPORARY_URL}`,
  'getSignedUrlS3',
  {
    withoutNormalize: true,
  },
);

// export const uploadFileToServer = query.wrapper<UploadFileToServer, UploadFileToServerApiItem>(
//   'upload',
//   async ({data: {fileName, filePath, module}}, dispatch, onError, getState) => {
//     try {
//       const resp = await RNFetchBlob.fetch(
//         'POST',
//         appConfig.api.url + ENDPOINTS.UPLOAD_FILE,
//         {
//           Authorization: `Bearer ${getState().auth?.token}`,
//           // this is required, otherwise it won't be process as a multipart/form-data request
//           'Content-Type': 'multipart/form-data',
//         },
//         [
//           {
//             name: 'file',
//             filename: fileName,
//             data: RNFetchBlob.wrap(decodeURIComponent(filePath.replace('file://', ''))),
//           },
//           {name: 'module', data: module},
//         ],
//       );
//       return resp?.json()?.data || ({} as UploadFileToServerApiItem);
//     } catch (e) {
//       new AppError(e, '', {
//         debugMessage: `Upload photo failed!:
//          If you got "SyntaxError: JSON Parse error: Unexpected token: <", usually it's because of: 413 Entity too large`,
//       });
//       onError(e);
//     }
//     return {} as UploadFileToServerApiItem;
//   },
// );
// export const fetchApps = query.fetch<FetchAppsParams, AppApiItem[]>(ENDPOINTS.APPS, '', {
//   withoutNormalize: true,
// });
// export const updateApp = query.put<UpdateAppParams, AppApiItem>(`${ENDPOINTS.APPS}/:id`, '', {
//   withoutNormalize: true,
// });
// export const deleteApp = query.delete<DeleteParams, AppApiItem>(`${ENDPOINTS.APPS}/:id`, '', {
//   withoutNormalize: true,
// });
//
